module.exports = __webpack_public_path__ + "static/media/llanta-medicion-mm-amarrillo.47a07154.svg";